import { createApp } from 'vue'

import App from './App.vue'

import Antd from 'ant-design-vue';

//import protobufPlugin from './js/protobuf-plugin';

import 'ant-design-vue/dist/antd.css';

import router from './router'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

const app = createApp(App).use(router).use(Antd)//.use(protobufPlugin);

app.mount('#app')
